// @ts-strict-ignore
import { css } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as ss from 'styled-system';

import { fontWeights, transition } from 'theme';

const size = (props: {
  fontSize?: string | number;
  p?: string | number;
  size?: 'small' | 'medium' | 'large';
}) => {
  switch (props.size) {
    case 'small':
      return {
        fontSize: props.fontSize || '14px',
        padding: !props.p && '0.4em 1.2em',
      };

    case 'large':
      return {
        fontSize: props.fontSize || '18px',
        padding: !props.p && '12px 24px',
      };

    default:
      return {
        fontSize: props.fontSize || '16px',
        padding: !props.p && '8px 16px',
      };
  }
};

export const buttonStyles = css<{
  square?: boolean;
  fontSize: string | number;
  p: string | number;
  size?: 'small' | 'medium' | 'large';
}>`
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  font-family: inherit;
  font-weight: ${fontWeights.semiBold};
  letter-spacing: 0.5px;
  line-height: 1.3;
  cursor: pointer;
  border-radius: ${(props) =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    !props.square ? '9999px' : props.size === 'small' ? '4px' : '7px'};
  transition: all ${transition};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  ${size}
  ${ss.borderRadius}
  ${ss.boxShadow}
`;
